export const moduleSlug = "BRANDS";

export const brandsFields = { name: "name" };

export default { moduleSlug };